import http from "../utils/http";

export const saveStorage = ({ files, code, imgPre, type }) => {
  const data = new FormData();
  data.append("file", files);
  data.append("code", code);
  data.append("imgPre", imgPre);
  data.append("type", type);
  return http.post("/upload/saveStorage", data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const download = (url) => {
  return http.get("/download", {
    params: {
      url,
    },
  });
};
